import '../App.css';
import axios from 'axios';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { useEffect, useState } from 'react';

import { useNavigate, useSearchParams } from "react-router-dom";
import Header from '../Header';
import DeviceHeader from './DeviceHeader';
import V2Card from '../V2Card';

function DeviceManageContent({ menu }) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [device, setDevice] = useState(null);

    const [allowExternalAdvertisers, setAllowExternalAdvertisers] = useState(false);

    // TODO: remove dup.
    function getDevice(device_id) {
        axios.get(
            process.env.REACT_APP_API_HOST + `/devices/${device_id}/`,
            {}
        ).then(
            (response) => {
                const device = response.data;
                setDevice(device);
                setAllowExternalAdvertisers(
                    device.allow_external_advertisers,
                );
            }
        )
    }

    function patchDevice(device_id, data) {
        axios.patch(
            process.env.REACT_APP_API_HOST + `/devices/${device_id}/`,
            data
        ).then(
            (response) => {
                navigate('/devices/');
            }
        )
    }

    useEffect(
        () => {
            getDevice(searchParams.get('device_id'));
        },
        [],
    )

    return (
        <div align='left'>
            {menu}
            <DeviceHeader title='Manage Content' />
            <V2Card>
                <div
                    style={{
                        display: 'flex',
                        cursor: 'pointer',
                        marginTop: '1em',
                    }}
                    onClick={() => setAllowExternalAdvertisers(!allowExternalAdvertisers)}
                >
                    <Checkbox checked={allowExternalAdvertisers} />
                    <div style={{ marginLeft: '0.5em' }}>
                        Allow campaigns from external advertisers.
                    </div>
                </div>
                <Button
                    label="Save"
                    severity="success"
                    onClick={
                        () => {
                            patchDevice(
                                searchParams.get('device_id'),
                                {
                                    allow_external_advertisers: allowExternalAdvertisers,
                                }
                            )
                        }
                    }
                    size='small'
                    outlined
                    style={{ marginTop: '1em' }}
                />
            </V2Card>
        </div>
    );
}

export default DeviceManageContent;